export const NEW_PHOTO_ATTACHMENT_ID_PREFIX = 'new-uploaded-photo-';